<template>
  <b-tabs lazy content-class="mt-3" v-model="aciveTab">
    <b-tab @click="parentTabClick" lazy title="Text" active>
      <b-tabs lazy pills card vertical v-if="aciveTab == 0">
        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab
          @click="tabClick(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <!-- translation form wrappe -->
          <div>
            <b-form-group label="Label">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="label"
                type="text"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- slides tabb -->
    <b-tab @click="parentTabClick" lazy title="slides">
      <!-- select slides tab -->
      <b-tabs lazy pills card vertical v-if="aciveTab == 1">
        <b-tab
          lazy
          @click="tabClick(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <div class="active text-left mt-2">
            <table class="table table-sm" v-if="language.toLowerCase() == translationLanguage">
              <thead>
                <tr class="text-center">
                  <th>Slide Image</th>
                  <th>Slide Timer</th>
                  <th>Slide Text</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(slide, slideIndex) in renderFilesPerLanguage"
                  :key="slideIndex"
                >
                  <td class="pr-2 pt-1 pl-2">
                    <b-form-input
                      :value="
                        slide[translationLanguage]
                          ? slide[translationLanguage].filename
                          : null
                      "
                      disabled
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :value="
                        slide[translationLanguage]
                          ? slide[translationLanguage].caption
                          : null
                      "
                      @input="addSlideCaption($event, slideIndex, slide)"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :value="
                        slide[translationLanguage]
                          ? slide[translationLanguage].text
                          : null
                      "
                      @input="addSlideText($event, slideIndex, slide)"
                    ></b-form-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- ----------------Advanced------------------- -->
    <b-tab @click="parentTabClick" lazy title="Advanced">
      <div @submit.stop.prevent class="text-left mt-4" v-if="aciveTab == 2">
        <div class="col-12">
          <div class="form-group col-md-6">
            <label for>Slide Show Interval</label>
            <b-form-input v-model="slideInterval" type="number"></b-form-input>
          </div>
          <b-form-checkbox v-model="slideControls"
            >Show Inside Controls</b-form-checkbox
          >
          <b-form-checkbox v-model="slideControlsOuter"
            >Show Outside Controls</b-form-checkbox
          >
          <b-form-checkbox v-model="slideBars">Show Bars</b-form-checkbox>
          <br />
        </div>
      </div>
    </b-tab>

    <!-- ----------------Dropzone------------------- -->
    <b-tab @click="parentTabClick" lazy title="Upload Slides">
      <b-overlay :show="isUploading">
      <b-tabs lazy pills card vertical v-if="aciveTab == 3">
        <b-tab
          lazy
          @click="tabClickUploadSlides(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <vue-dropzone
            ref="vueDropzone"
            @vdropzone-success="vsuccess"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-sending="sendingEvent"
            @vdropzone-upload-progress="onUploadImage"
            @vdropzone-queue-complete="onUploadFinish"
            :useCustomSlot="true"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">
                Drag and drop to upload content!
              </h3>
              <div class="subtitle">
                ...or click to select a file from your computer
              </div>
            </div>
          </vue-dropzone>
          <b-row>
            <b-col cols="12">
              <table
                class="table table-striped"
                v-if="language.toLowerCase() == translationLanguage"
              >
                <thead class="thead-dark">
                  <tr>
                    <th></th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Size</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <draggable v-model="files" tag="tbody" ghost-class="ghost">
                  <tr v-for="(item, index) in files"
                    :key="item[translationLanguage]? item[translationLanguage].fileId: index" class="sort"
                  >
                    <td v-if="item[translationLanguage]">{{ index + 1 }}</td>
                    <td v-if="item[translationLanguage]">
                      <b-img-lazy
                        v-bind="thumbnailProps"
                        thumbnail
                        :src="item[translationLanguage].url"
                      ></b-img-lazy>
                    </td>
                    <td v-if="item[translationLanguage]">
                      {{
                        item[translationLanguage]
                          ? item[translationLanguage].filename
                          : ""
                      }}
                    </td>
                    <td v-if="item[translationLanguage]">
                      {{
                        item[translationLanguage]
                          ? item[translationLanguage].type
                          : ""
                      }}
                    </td>
                    <td v-if="item[translationLanguage]">
                      {{
                        readableBytes(
                          item[translationLanguage]
                            ? item[translationLanguage].size
                            : ""
                        )
                      }}
                    </td>
                    <td v-if="item[translationLanguage]">
                      <font-awesome-icon
                        style="cursor:pointer"
                        icon="trash"
                        @click="onDeleteSlide(index, item)"
                      />
                    </td>
                    <td v-if="item[translationLanguage]">
                      <font-awesome-icon icon="bars" />
                    </td>
                  </tr>
                </draggable>
              </table>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      </b-overlay>
    </b-tab>
  </b-tabs>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import draggable from "vuedraggable";
import { EventBus } from "@/event-bus.js";
// import vue2Dropzone from "vue2-dropzone";
import vue2Dropzone from "./Dropzone/VueDropzone.vue";
import uid from "uid";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  components: {
    vueDropzone: vue2Dropzone,
    draggable,
  },
  name: "AdvanceTrainingSettings",
  data() {
    return {
      isUploading:false,
      aciveTab: 0,
      // translationLanguage: "english",
      fileData: { english: null },
      files: [],
      fields: ["filename", "type", "size", ""],
      isLoading: false,
      translationLanguage: "english",
      label: undefined,
      slideText: "",
      slideCaption: "",
      slideImg: null,
      file: null,
      imgUrl: null,
      thumbnailProps: { width: 90, height: 90 },
      slideInterval: this.fieldData.interval,
      slideControls: this.fieldData.controls,
      slideControlsOuter: this.fieldData.controlsOut,
      slideBars: this.fieldData.indicators,
      dropzoneOptions: {
        //url: 'https://httpbin.org/post',
        url: process.env.VUE_APP_API_URL + "v1/uploads/file/form",
        thumbnailWidth: 150,
        maxFilesize: 10,

        //parallelUploads:50,
        // addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      },
    };
  },
  computed: {
    ...mapGetters({ form: "form1" }),
      renderFilesPerLanguage() {
        const files = this.fieldData.files.filter(file => file[this.translationLanguage])
        return files
    },
    renderFiles(){
       const files = this.files.filter(file => file[this.translationLanguage])
        return files
    }
  },

  mounted() {
    this.tabClickUploadSlides("English");
    this.label = this.fieldData.label[this.translationLanguage];
    this.files = this.fieldData.files || [];
  },

  created() {
    EventBus.$on("onSaveSettings", (value) => {
      this.addLanguageToField(this.translationLanguage);
      this.onUpdatCarouselSettings();
      Object.assign(this.fieldData, { files: this.files });
    });
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
    parentTabClick(){
      this.translationLanguage = "english";
    },
    readableBytes(bytes) {
      var i = Math.floor(Math.log(bytes) / Math.log(1024)),
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
    },

    onUploadImage(file, progress, bytesSent) {
      this.isUploading = true;
      console.log("uploading....");
      EventBus.$emit("onUploadStart", "uploading image");
    },

    onUploadFinish() {
      console.log("finsish....");
      this.isUploading = false;
      EventBus.$emit("onUploadCompleting", "uploading image");
    },

    vsuccess(file, response) {
      let self = this;
      let uploadedFile = {};
      if (response && response.url) {
        this.imgSrc = response.url;
        uploadedFile[self.translationLanguage] = {
          fileId: uid(),
          filename: file.name,
          caption: this.slideCaption,
          text: this.slideText,
          size: file.size,
          type: file.type,
          url: response.url,
        };
        this.files.push(uploadedFile);
        // this.removeAllFiles();
        // this.$refs.vueDropzone.removeFile(file);
      }
    },

    removeAllFiles() {
      this.$refs.vueDropzone.removeAllFiles();
    },

    /**
     * dropzone js send additional params
     */
    sendingEvent(file, xhr, formData) {
      formData.append("formId", this.form.formId);
      formData.append("fieldId", this.fieldData.id);
      formData.append("fieldIndex", this.fieldIndex);
      formData.append("sectionIndex", this.fieldIndex);
      formData.append("sectionId", this.fieldIndex);
    },

    tabClickUploadSlides(language) {
      this.translationLanguage = null;
      let tempKey = language.toLowerCase();
      this.translationLanguage = tempKey;
      // console.log(this.translationLanguage, "language");
      this.imgUrl = this.fileData[this.translationLanguage];
      //   this.imgUrl = this.fieldData.files[this.translationLanguage];
    },

    tabClick(language) {
      let tempKey = language.toLowerCase();
      this.translationLanguage = tempKey;
      this.label = this.fieldData.label[this.translationLanguage];
    },

    addLanguageToField(language) {
      let tempKey = language.toLowerCase();
      this.fieldData.label[tempKey] = this.label;
    },

    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },

    // for addiing slides
    addSlideImg(value, slideIndex) {
      let imageFile = value;
      if (imageFile.type !== "image/jpeg" && imageFile.type !== "image/png") {
        alert("You can only upload JPG and PNG file!");
      } else if (imageFile.size > 3769152) {
        alert("Image must smaller than 4MB!");
      } else if (imageFile) {
        this.getBase64(imageFile, (imageUrl) => {
          this.slideImg = imageFile;
          this.imgUrl = imageUrl;
          this.fieldData.slideData[slideIndex].imgSrc = imageUrl;
          this.fieldData.slideData[slideIndex].imgName = imageFile.name;
        });
      } else {
        alert("Image Error please try later");
      }
    },

    addSlideCaption(value, slideIndex, slide) {
      this.slideCaption = value;
      slide[this.translationLanguage].caption = value
      // this.fieldData.files[slideIndex][this.translationLanguage].caption[
      //   this.translationLanguage
      // ] = value;
    },

    addSlideText(value, slideIndex, slide) {
      this.slideText = value;
      slide[this.translationLanguage].text = value
      // this.fieldData.files[slideIndex][this.translationLanguage].text[
      //   this.translationLanguage
      // ] = value;
    },

    addSlide() {
      let newSlide = {
        caption: { english: this.slideCaption },
        text: { english: this.slideText },
        imgBblank: this.imgSrc ? true : false,
        imgSrc: this.imgSrc,
      };

      // console.log("newOptiopn", newOptiopn)
      this.fieldData.slideData.push(newSlide);
    },

    onDeleteSlide(index, file) {
      if (
        this.files.length > 0 &&
        this.fieldData.files &&
        this.fieldData.files.length > 0
      ) {
        this.fieldData.files.splice(index, 1);
      }
      if (this.files.length > 0) {
        this.files.splice(index, 1);
      }

      // console.log("onDeleteSlide", this.files);
      // this.files = this.fieldData.files || [];
    },

    onUpdatCarouselSettings() {
      this.fieldData.interval = this.slideInterval;
      this.fieldData.controls = this.slideControls;
      this.fieldData.controlsOut = this.slideControlsOuter;
      this.fieldData.indicators = this.slideBars;
    },

    showToast(variant = null, message) {
      this.$bvToast.toast(message, {
        // title: `Clone ${variant || "default"}`,
        title: "Alert",
        variant: variant,
        solid: true,
      });
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionId: {
      type: String,
      required: false,
    },
    sectionIndex: {
      type: Number,
      required: false,
    },
    fieldIndex: {
      type: Number,
      required: false,
    },
  },
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.sort {
  cursor: move;
}
</style>
